import {
  inboundShipmentIdFormat,
  locationIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createPurchaseOrderShipment = {
  name: "createPurchaseOrderShipment" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    locationId: locationIdFormat.schema.nullish(),
    carrier: z.string().nullish(),
    estimatedArrivalDate: zExt.plainDate().nullish(),
    actualArrivalDate: zExt.plainDate().nullish(),
    freightType: z.string().nullish(),
    paymentTerms: z.string().nullish(),
    shipmentId: z.string().nullish(),
    trackingNumber: z.string().nullish(),
    trackingUrl: z.string().nullish(),
    freightCost: z.number(),
    freightCurrency: z.string(),
    dutyCost: z.number(),
    dutyCurrency: z.string(),
  }),
  output: z.object({
    shipment: z.object({
      id: inboundShipmentIdFormat.schema,
      locationId: locationIdFormat.schema.nullish(),
      carrier: z.string().nullish(),
      estimatedArrivalDate: zExt.plainDate().nullish(),
      actualArrivalDate: zExt.plainDate().nullish(),
      freightType: z.string().nullish(),
      paymentTerms: z.string().nullish(),
      shipmentId: z.string().nullish(),
      trackingNumber: z.string().nullish(),
      trackingUrl: z.string().nullish(),
      freightCost: z.number(),
      freightCurrency: z.string(),
      dutyCost: z.number(),
      dutyCurrency: z.string(),
    }),
  }),
};
